export { default as GDMTableDesktop } from './GDMTableDesktop';
